export default "__VITE_ASSET__dcb1ba09__"